module.exports = __webpack_public_path__ + "img/box9-04.d6dd4568.png";